var TransferType;
(function (TransferType) {
    TransferType["TRANSFER"] = "Transfer";
    TransferType["CASH"] = "Cash";
})(TransferType || (TransferType = {}));
var TransferMethod;
(function (TransferMethod) {
    TransferMethod["NORMAL"] = "Normal";
    TransferMethod["TRANSFERASGROUP"] = "TransferAsGroup";
    TransferMethod["TRANSFERPERTERM"] = "TransferPerTerm";
})(TransferMethod || (TransferMethod = {}));
var PajakType;
(function (PajakType) {
    PajakType["PAJAK"] = "Pajak";
    PajakType["NONPAJAK"] = "NonPajak";
})(PajakType || (PajakType = {}));
var PajakMethod;
(function (PajakMethod) {
    PajakMethod["INCLUDED"] = "Included";
    PajakMethod["EXCLUDED"] = "Excluded";
})(PajakMethod || (PajakMethod = {}));
var PajakCategory;
(function (PajakCategory) {
    PajakCategory["PPH21"] = "PPh21";
    PajakCategory["PPH23"] = "PPh23";
    PajakCategory["PPH23PLUSPPN"] = "PPh23PlusPPN";
    PajakCategory["PPH26"] = "PPh26";
})(PajakCategory || (PajakCategory = {}));
var NpwpStatus;
(function (NpwpStatus) {
    NpwpStatus["NPWP"] = "have-npwp";
    NpwpStatus["NotNPWP"] = "not-have-npwp";
})(NpwpStatus || (NpwpStatus = {}));
var TermStatus;
(function (TermStatus) {
    TermStatus["NEXTTERM"] = "NextTerm";
    TermStatus["ALLTERMSCOMPLETED"] = "AllTermsCompleted";
})(TermStatus || (TermStatus = {}));
export { TransferType, TransferMethod, PajakType, PajakMethod, PajakCategory, NpwpStatus, TermStatus };
